<template>
  <!-- <b-card class="realtime-kpi-strip" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">Overview</h6>
    </template>
    <b-card-body> -->
      <b-row>
        <b-col cols="6" sm="6" md="6" lg="6">
          <kpi-card
            title="New Leads"
            :value="kpiData.new_leads.count"
            :trend="kpiData.new_leads.trend"
            color="blue darken-1"
          />
        </b-col>
        <b-col cols="6" sm="6" md="6" lg="6">
          <kpi-card
            title="Total Calls"
            :value="kpiData.total_calls.count"
            :trend="kpiData.total_calls.trend"
            color="green darken-1"
          />
        </b-col>
        <b-col cols="6" sm="6" md="6" lg="6">
          <kpi-card
            title="Site Visits"
            :value="kpiData.site_visits.count"
            :trend="kpiData.site_visits.trend"
            color="orange darken-1"
          />
        </b-col>
        <b-col cols="6" sm="6" md="6" lg="6">
          <kpi-card
            title="Closures"
            :value="kpiData.closures.count"
            :trend="kpiData.closures.count_trend"
            color="purple darken-1"
          />
        </b-col>
      </b-row>
    <!-- </b-card-body>
  </b-card>
</template> -->
</template>

<script>
import KpiCard from './KpiCard.vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

import { BRow, BCol, BCard, BCardBody } from 'bootstrap-vue';

export default {
  name: 'RealtimeKpiStrip',
  components: {
    KpiCard,
    BCard,
    BCardBody,
    BRow,
    BCol,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: {
      type: Object,
      default: null,
    },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      kpiData: {
        new_leads: { count: 0, trend: null },
        total_calls: { count: 0, trend: null },
        site_visits: { count: 0, trend: null },
        closures: { count: 0, value: 0, count_trend: null, value_trend: null },
      },
      pollingInterval: null,
    };
  },
  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.realtime_kpi != null && hasRight(this.user, 'dashboard', 'view')) {
          this.kpiData = val.realtime_kpi;
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.realtime_kpi != null) this.kpiData = this.dashboardData.realtime_kpi;
          return;
        }
        if (this.dashboardData && this.dashboardData.realtime_kpi != null) {
          this.kpiData = this.dashboardData.realtime_kpi;
          return;
        }
        this.fetchKpiData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.realtime_kpi != null) this.kpiData = this.dashboardData.realtime_kpi;
            return;
          }
          this.startPolling();
          this.fetchKpiData();
        } else {
          this.stopPolling();
          this.kpiData = {
            new_leads: { count: 0, trend: null },
            total_calls: { count: 0, trend: null },
            site_visits: { count: 0, trend: null },
            closures: { count: 0, value: 0, count_trend: null, value_trend: null },
          };
        }
      },
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    hasRight, // Make the helper available in the template
    async fetchKpiData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.realtime_kpi != null)) {
        if (this.dashboardData && this.dashboardData.realtime_kpi != null) this.kpiData = this.dashboardData.realtime_kpi;
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/realtime-kpi', this.filters);
        this.kpiData = response.data.data;
      } catch (error) {
        console.error('Error fetching real-time KPI data:', error);
        // Handle error, e.g., show a message to the user
      }
    },
    startPolling() {
      if (this.useAggregate) return;
      this.pollingInterval = setInterval(this.fetchKpiData, 30000);
    },
    stopPolling() {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    },
  },
};
</script>

<style scoped>
.realtime-kpi-strip {
  margin-top: 20px;
}
</style>